import React, { useEffect, useState } from "react";
import StripeCheckout from "react-stripe-checkout";

import { apiURL } from "../api";
import { useNavigate } from "react-router-dom";
import emailjs from "emailjs-com";

function Service(props) {
  const imageArray = new Uint8Array(props.service.image.data.data);
  let str = "";
  for (let i = 0; i < imageArray.length; i++) {
    str += String.fromCharCode(imageArray[i]);
  }
  const base64String = btoa(str);

  const Navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(false);
  const [data, setData] = useState({});

  const CheckLogin = async () => {
    try {
      const res = await fetch(`${apiURL}/check`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      const userData = await res.json();
      setData(userData);

      setIsLogin(true);
    } catch (error) {
      setIsLogin(false);
    }
  };
  useEffect(() => {
    CheckLogin();
  });

  const sendEmail = () => {
    const emailParams = {
      user_email: data.email,
      user_subject: "Hello From Digital Mechanic",
      message: `Hi ${data.name}, and Thanks for booking ${props.service.title} of ${props.service.price}. Your mechnaic is on the way, in the meanwhile you can confirm your order status on the bookings page or bookings screen of your mobile and website.`,
    };

    emailjs
      .send(
        "service_o2a6p2p",
        "template_ejext9s",
        emailParams,
        "user_2agKQgT6Jx0WnwCl0pwPP"
      )
      .then((result) => {
        console.log(result.text);
      })
      .catch((error) => {
        console.log(error.text);
      });
  };

  const makeBooking = (token) => {
    const body = {
      amount: props.service.price,
      title: props.service.title,
      token,
      name: props.name,
      city: props.city,
      status: "Pending",
      address: props.address,
    };

    const headers = {
      "Content-Type": "application/json",
    };

    return fetch(`${apiURL}/booking`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    })
      .then(() => {
        sendEmail();
        Navigate("/");
      })
      .catch((error) => console.log(error));
  };

  const stripeKey = process.env.REACT_APP_STRIPE_CLIENT_SIDE_KEY;

  return (
    <div
      style={{ minWidth: "300px" }}
      className="flex flex-col my-2 mx-2 border border-gray-300 rounded-3xl p-2"
    >
      <img
        className="rounded-3xl"
        src={`data:mimeType;base64,${base64String}`}
        alt="serviceImage"
        style={{ objectFit: "cover", height: "250px", width: "300px" }}
      />
      <p className="text-lg text-secondary pt-2 font-semibold">
        {props.service.category.slice(0, -1)} Service
      </p>
      <span className="font-semibold text-xl py-1">{props.service.title}</span>
      <span className="text-xl py-1 text-gray-500">Service at Home</span>
      <div className="flex justify-between items-center">
        <span className="text-xl py-1">
          Start at
          <span className="pl-2 font-semibold text-green-600">
            ${props.service.price}
          </span>
        </span>
        {isLogin ? (
          <StripeCheckout
            stripeKey={stripeKey}
            token={makeBooking}
            name="Digital Mechanic"
            amount={props.service.price * 100}
          >
            <button className="text-white bg-primary p-2 rounded-sm w-full">
              Pay ${props.service.price}
            </button>
          </StripeCheckout>
        ) : (
          <button
            onClick={() => Navigate("/login")}
            className="text-white bg-black p-3 rounded-sm"
          >
            Book Now
          </button>
        )}
      </div>
    </div>
  );
}

export default Service;
